export enum Page {
  dashboard = 'dashboard',
  permissions = 'permissions',
  security = 'security',
  caseSetup = 'case-setup',
  claimscoreSettings = 'claimscore-settings',
  scheduledReports = 'scheduled-reports',
  files = 'files',
  developerTools = 'developer-tools',
  classresolution = 'classresolution',
  deepvalidation = 'deepvalidation',
  exports = 'exports',
}
